const API_URL = process.env.REACT_APP_API_URL;
const getCsrfToken = () => {
    // Log all cookies to see what we're working with
    
    // Split all cookies and log each one for debugging
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    
    // Find the csrftoken cookie
    const csrfCookie = cookies.find(cookie => cookie.startsWith('csrftoken='));
    
    // Extract just the token value
    const token = csrfCookie ? csrfCookie.split('=')[1] : null;
    
    return token;
};

const authService = {
    login: async (credentials) => { 
        try {
            
            const csrfResponse = await fetch(`${API_URL}/api/login/`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            await new Promise(resolve => setTimeout(resolve, 100));

            if (!csrfResponse.ok) {
                throw new Error('Failed to get CSRF token');
            }

            const csrfData = await csrfResponse.json();
            
            // Get the CSRF token from either the cookie or the response
            const csrfToken = getCsrfToken() || csrfData.csrfToken;

            if (!csrfToken) {
                throw new Error('No CSRF token available');
            }
            localStorage.setItem('csrfToken', csrfToken);

            // Continue with login POST request
            const loginResponse = await fetch(`${API_URL}/api/login/`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(credentials)
            });

            if (!loginResponse.ok) {
                const data = await loginResponse.json();
                console.error('Login response not OK:', loginResponse.status, data); // Debug line
                throw new Error(data.detail || 'Invalid credentials');
            }

            const data = await loginResponse.json();

            if (data.success) {
                localStorage.setItem('isAdmin', 'true');
                if (data.user) {
                    localStorage.setItem('user', JSON.stringify(data.user));
                }
                return true;
            }
            throw new Error('Login failed');
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    },

    logout: async () => {
        try {
            const csrfResponse = await fetch(`${API_URL}/api/login/`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            await new Promise(resolve => setTimeout(resolve, 100));

            if (!csrfResponse.ok) {
                throw new Error('Failed to get CSRF token');
            }

            const csrfData = await csrfResponse.json();
            
            // Get the CSRF token from either the cookie or the response
            const csrfToken = getCsrfToken() || csrfData.csrfToken;

            if (!csrfToken) {
                throw new Error('No CSRF token available');
            }
            localStorage.setItem('csrfToken', csrfToken);


            await fetch(`${API_URL}/api/logout/`, {
                method: 'POST',
                headers: {
                    'X-CSRFToken': csrfToken,
                },
                credentials: 'include',
            });
            localStorage.removeItem('isAdmin');
        } catch (error) {
            console.error('Logout error:', error);
        }
    },

    isAuthenticated: () => {
        return localStorage.getItem('isAdmin') === 'true';
    }
};

export default authService;